import axios from "axios";
import { serviceBaseUrl } from "./constants";

export const scoresService = {

  addScore: async (score: any) => {
    const response = await axios.post(`${serviceBaseUrl}/addScore`, score);
    return response.data;
  },

  updateScore: async (score: any) => {
    const response = await axios.put(`${serviceBaseUrl}/updateScore/${score.id}`, score);
    return response.data;
  },

  uploadScores: async (scores: any) => {
    const response = await axios.post(`${serviceBaseUrl}/uploadScores`, scores);
    return response.data;
  },

  getScoresToStartEntry: async (playerId: string) => {
    const response = await axios.get(
      `${serviceBaseUrl}/scoreEntryByPlayer/${playerId}`
    );
    return response.data;
  },

  getScoresToStartEntryAdmin: async () => {
    const response = await axios.get(
      `${serviceBaseUrl}/scoreEntryByAdmin`
    );
    return response.data;
  },



  addMatchPlayScore: async (score: any) => {
    const response = await axios.post(`${serviceBaseUrl}/addMatchPlayScore`, score);
    return response.data;
  },

  updateMatchPlayScore: async (score: any) => {
    const response = await axios.put(`${serviceBaseUrl}/updateMatchPlayScore/${score.id}`, score);
    return response.data;
  },

  uploadMatchPlayScores: async (scores: any) => {
    const response = await axios.post(`${serviceBaseUrl}/uploadMatchPlayScores`, scores);
    return response.data;
  },


};
